export const low_numberOfStrands = 6;
export const low_strands = [
  'GGCAACTTTGATCCCTCGGTTTAGCGCCGGCCTTTTCTCCCACACTTTCACG',
  'GGGAAATTTCGTGGTAGGTTTTGTTGCCCGTGTTTCTACGATTACTTTGGTC',
  'GGACATTTTCGAGACAGCATTTTTTCCCGACCTTTGCGGATTGTATTTTAGG',
  'GGCGCTTTTGACCTTCTGCTTTATGTCCCCTATTTCTTAATGACTTTTGGCC',
  'GGGAGATTTAGTCATTAAGTTTTACAATCCGCTTTGTAATCGTAGTTTGTGT',
  'GGGATCTTTACCTACCACGTTTTGCTGTCTCGTTTGCAGAAGGTCTTTCCGA'
];